<div class="relative flex flex-col w-full h-full">

  <!-- Dismiss button -->
  @if (data.dismissible) {
    <div class="absolute top-0 right-0 pt-4 pr-4">
      <button
        mat-icon-button
        [matDialogClose]="undefined">
        <mat-icon
          class="text-secondary"
        [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }

  <!-- Content -->
  <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

    <!-- Icon -->
    @if (data.icon.show) {
      <div
        class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full"
                [ngClass]="{'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600': data.icon.color === 'primary',
                            'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600': data.icon.color === 'accent',
                            'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600': data.icon.color === 'warn',
                            'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600': data.icon.color === 'basic',
                            'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600': data.icon.color === 'info',
                            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500': data.icon.color === 'success',
                            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500': data.icon.color === 'warning',
                            'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600': data.icon.color === 'error'
                            }">
        <mat-icon
          class="text-current"
        [svgIcon]="data.icon.name"></mat-icon>
      </div>
    }

    @if (data.title || data.message) {
      <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
        <!-- Title -->
        @if (data.title) {
          <div
            class="text-xl leading-6 font-medium"
          [innerHTML]="data.title"></div>
        }
        <!-- Message -->
        @if (data.message) {
          <div
            class="text-secondary"
          [innerHTML]="data.message"></div>
        }
        <!-- Input -->
        @if (data.nameInput) {
          <form [formGroup]="inputForm" class="w-full" >
            <!-- Name -->
            <div class=" mt-6">
              <mat-form-field
                class="w-full"
                [subscriptSizing]="'dynamic'">
                <mat-label>{{ data.nameInput }}</mat-label>
                <input [(ngModel)]="inputValue"
                  [formControlName]="'name'"
                  matInput>
                </mat-form-field>
              </div>
              @if (!users) {
                <div class=" mt-6">
                  <mat-form-field
                    class="w-full"
                    [subscriptSizing]="'dynamic'">
                    <mat-label>Depende del siguiente cargo:</mat-label>
                    <mat-icon
                      class="icon-size-5"
                      [svgIcon]="'mat_outline:business'"
                    matPrefix></mat-icon>
                    <mat-select [formControlName]="'position'" [(ngModel)]="parentPosition" (selectionChange)="onParentChange($event)">
                      @if (showRootOption) {
                        <mat-option [value]="-1">Cargo raíz</mat-option>
                      }
                      @if (!showRootOption) {
                        <mat-option [value]="-1" [disabled]="true">
                          <span class="text-gray-400">Cargo raíz (ya existe uno)</span>
                        </mat-option>
                      }
                      @if (positions) {
                        @for (position of positions; track position) {
                          <mat-option [value]="position.id">{{position.name}}</mat-option>
                        }
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (!users) {
                <div class=" mt-6">
                  <mat-form-field
                    class="w-full"
                    [subscriptSizing]="'dynamic'">
                    <mat-label>Departamento</mat-label>
                    <mat-select [formControlName]="'department'">
                      @for (option of departmentOptions; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                      }
                    </mat-select>
                    </mat-form-field>
                  </div>
                }
                @if (users) {
                  <div class=" mt-6">
                    <mat-form-field
                      class="w-full"
                      [subscriptSizing]="'dynamic'">
                      <mat-label>Empleado:</mat-label>
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_outline:user-group'"
                      matPrefix></mat-icon>
                      <mat-select [formControlName]="'user'" [(ngModel)]="currentUser" >
                        @if (users) {
                          @for (user of users; track user) {
                            <mat-option [value]="user.id">{{user.name}}</mat-option>
                          }
                        }
                        @if (!user || user.length == 0) {
                          <mat-option [value]="-1">Sin asignar</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              </form>
            }
          </div>
        }

      </div>


      <!-- Actions -->
      @if (data.actions.confirm.show || data.actions.cancel.show) {
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
          <!-- Cancel -->
          @if (data.actions.cancel.show) {
            <button
              mat-stroked-button
              [matDialogClose]="'cancelled'">
              {{data.actions.cancel.label}}
            </button>
          }
          <!-- Confirm -->
          @if (data.actions.confirm.show) {
            <button
              mat-flat-button
              [disabled]="(validate)?null:'disabled'"
              [color]="data.actions.confirm.color"
              [matDialogClose]="(!currentUser)?{ 'name': inputValue, 'parent': parentPosition === -1 ? null : parentPosition, 'department' : inputForm.get('department').value }:{ 'name': inputValue, 'user': currentUser, 'initCurrentUser': initCurrentUser }">
              {{btn_text?btn_text:data.actions.confirm.label}}
            </button>
          }
        </div>
      }

    </div>
